import { useEffect, useState } from "react";
import AddButton from "../../../../components/AddButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import SaveButton from "../../../../components/SaveButton";
import TextInput from "../../../../components/TextInput";
import TableFilters from "../TableFilters";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import {
  addStateDistributionChannel,
  editStateDistributionChannel,
  selectedRowsStateDistributionChannel,
} from "./atoms/atoms";
import { useGetDistributionChannel } from "./hooks/useGetDistributionChannel";
import useAddDistributionChannel from "./hooks/useAddDistributionChannel";
import useDeleteDistributionChannel from "./hooks/useDeleteDistributionChannel";
import useUpdateDistributionChannel from "./hooks/useUpdateDistributionChannel";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { useHistory, useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import MaterialProducerCodeConfigTable from "../../../../components/tables/MaterialProducerCodeConfigTable";

const DistributionChannelTable = () => {
  const queryClient = useQueryClient();
  const [distributionChannelData, setDistributionChannelData] = useState([]);
  const [disChannelFilteredData, setDisChannelFilteredData] = useState([]);
  const [editRowData, setEditRowData] = useState();
  const [addState, setAddState] = useRecoilState(addStateDistributionChannel);
  const [editState, setEditState] = useRecoilState(
    editStateDistributionChannel
  );

  const newRow = {
    distributionChannelId: 0,
    distributionChannelName: "",
    createdDate: null,
    createdBy: null,
    isActive: true,
  };

  const [newData, setNewData] = useState([newRow]);

  const [openModal, setOpenModal] = useState(false);
  const [updatedStatus, setUpdatedStatus] = useState(false);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateDistributionChannel
  );
  const [rowsCount, setRowsCount] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [, setDisabledButton] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [disableSave, setDisableSave] = useState(true);
  const distriChannelData = useGetDistributionChannel();
  const BulkDeleteDistributionChannel = useDeleteDistributionChannel();
  const editMGA = useUpdateDistributionChannel();
  const { mutateAsync: addDistributionChannel } = useAddDistributionChannel();

  const [, setMgaFilteredData] = useState([]);
  const [, setProdCodeTypeFilteredData] = useState([]);
  const [, setLOBTypeFilteredData] = useState([]);
  const [, setCProgramFilteredData] = useState([]);
  const [, setCodeLevelFilteredData] = useState([]);

  //Permission
  const hasEdit = PERMISSIONS.permission_utilities_distributionchannel_edit;
  const hasAdd = PERMISSIONS.permission_utilities_distributionchannel_add;
  const hasDelete = PERMISSIONS.permission_utilities_distributionchannel_delete;
  const userPermissions = useRecoilValue(permissionsSelector);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  //Filter
  const [dChannelId, setdChannelId] = useState("");
  useEffect(() => {
    if (filterText) {
      setDistributionChannelData(
        distriChannelData.data?.filter((x) =>
          x.distributionChannelName
            .toLowerCase()
            .includes(filterText.trim().toLowerCase())
        )
      );
    } else if (dChannelId?.includes(".")) {
      let dChannelIds = dChannelId.split(".");
      const dChannelIdsArr = dChannelIds.map((id) => Number(id));
      const filteredData = distriChannelData.data?.filter((x) =>
        dChannelIdsArr.includes(x.distributionChannelId)
      );

      setDisChannelFilteredData(filteredData);
    } else if (disChannelFilteredData?.length === 1) {
      const filteredData = distriChannelData.data?.filter(
        (x) => x.distributionChannelId === Number(dChannelId)
      );
      setDisChannelFilteredData(filteredData);
    } else {
      setDistributionChannelData(distriChannelData.data);
    }
    setEditState(false);
    setAddState(false);
  }, [filterText, distriChannelData.data]);

  useEffect(() => {
    if (recordIdFromRecent !== "") {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setDisChannelFilteredData(result);
          setdChannelId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
    setSelectedRows([]);
  }, []);

  //Cancel
  const handleCancel = () => {
    setEditState(false);
    setAddState(false);
    setEditRowData();
    setDisabledButton(false);
    setNewData([newRow]);
    setUpdatedStatus(false);
  };

  //handle input fields changes
  const handlesFieldsChange = (fieldName, value) => {
    if (addState) {
      setNewData((data) => [{ ...data[0], [fieldName]: value }]);
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    } else {
      //else Edit State
      setEditRowData({ ...editRowData, [fieldName]: value });
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    }
  };

  //handle Add Button
  const handleAdd = () => {
    setAddState(true);
    setDisabledButton(true);
    setUpdatedStatus(true);
  };

  //handle Edit Button
  const handleEdit = (rowData) => {
    setEditState(true);
    setDisabledButton(true);
    setEditRowData({ ...rowData });
    setUpdatedStatus(rowData.isActive);
  };

  //save changes
  const handleSave = () => {
    setOpenModal(false);
    if (addState) {
      addDistributionChannel(
        { ...newData },
        {
          onSuccess: (res) => {
            setDisabledButton(false);
            if (res.data === "duplicate") {
              toast.fire(
                "Failed",
                "Distribution Channel already exist",
                "error"
              );
            } else if (res.status === 201) {
              setAddState(false);
              setNewData([newRow]);
              queryClient.invalidateQueries("GetDistributionChannelList");
              toast.fire(
                "Success",
                "New Distribution Channel added successfully",
                "success"
              );
            } else {
              toast.fire(
                "Failed",
                "Server Error: Cannot add new Distribution Channel",
                "error"
              );
            }
          },
          onError: (error) => {
            if (
              error.response.data.message === "Failed sending of email" ||
              error.response.data.message === "Failed inserting of notification"
            ) {
              toast.fire(
                "Success",
                "New Distribution Channel added successfully, but " +
                  error.response.data.message,
                "warning"
              );
              queryClient.invalidateQueries("GetDistributionChannelList");
            } else {
              toast.fire(
                "Failed",
                "Server Error: Cannot add new Distribution Channel",
                "error"
              );
            }
          },
        }
      );
    } else {
      //else for if c
      const channelName = editRowData.distributionChannelName.trim();
      const channelData = distributionChannelData.filter(
        (x) => x.distributionChannelName === channelName
      );
      if (
        channelName === channelData[0]?.distributionChannelName &&
        editRowData.isActive === channelData[0]?.isActive
      ) {
        toast.fire("Saving Failed", "No Changes have been made", "warning");
        setOpenModal(false);
      } else {
        editMGA(editRowData);
      }
    }
  };

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.distributionChannelId);
    BulkDeleteDistributionChannel(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  useEffect(() => {
    if (
      newData[0].distributionChannelName?.length > 0 ||
      editRowData?.distributionChannelName?.length > 0
    ) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [newData[0], editRowData]);

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Distribution Channels" : "Distribution Channel"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "Distribution Channel Name",
      field: "distributionChannelName",
      customSort: (a, b) =>
        a.distributionChannelName && b.distributionChannelName
          ? a.distributionChannelName
              .trim()
              .localeCompare(b.distributionChannelName.trim())
          : a.distributionChannelName
          ? 0
          : -1,
      render: (rowData) => {
        return (rowData.distributionChannelId ===
          editRowData?.distributionChannelId &&
          editState) ||
          addState ? (
          <div className="w-full">
            <div className="grid grid-cols-1 space-x-2">
              <div className="">
                <TextInput
                  defaultValue={rowData.distributionChannelName}
                  onChange={(e) =>
                    handlesFieldsChange(
                      "distributionChannelName",
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full text-quinary font-bold uppercase text-base">
            {rowData.distributionChannelName}
          </div>
        );
      },
    },
    {
      title: "Created By",
      align: "left",
      field: "createdBy",
      hidden: addState || editState,
    },
    {
      title: "Created Date",
      align: "left",
      field: "createdDate",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      title: "Modified By",
      align: "left",
      field: "modifiedBy",
      hidden: addState || editState,
    },
    {
      title: "Modified Date",
      align: "left",
      field: "modifiedDate",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      field: "isActive",
      align: "left",
      title: "Status",
      render: (rowData) => {
        return (rowData.distributionChannelId ===
          editRowData?.distributionChannelId &&
          editState) ||
          addState ? (
          <div className="flex justify-start place-items-center  space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handlesFieldsChange("isActive", e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {updatedStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      hidden: addState,
      render: (rowData) => {
        return (rowData.distributionChannelId ===
          editRowData?.distributionChannelId &&
          editState) ||
          addState ? (
          <div className="flex justify-center space-x-1">
            <SaveButton
              buttonText="Save"
              disabled={
                disableSave ||
                (rowData?.distributionChannelName ===
                  editRowData?.distributionChannelName &&
                  rowData?.isActive === editRowData?.isActive)
              }
              onClick={() => setOpenModal(true)}
            />
            <CancelButton onClick={() => handleCancel()} />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            {userPermissions.includes(hasEdit) && (
              <EditButton
                disabled={editState || selectedRows.length > 0}
                onClick={() => {
                  handleEdit(rowData);
                }}
              />
            )}
          </div>
        );
      },
    },
  ];
  return (
    <div className="bg-white p-4 ">
      {!addState && (
        <>
          <div className="flex flex-row justify-between items-center">
            <TableFilters
              setMgaFilteredData={setMgaFilteredData}
              setDisChannelFilteredData={setDisChannelFilteredData}
              setCProgramFilteredData={setCProgramFilteredData}
              setLOBTypeFilteredData={setLOBTypeFilteredData}
              setProdCodeTypeFilteredData={setProdCodeTypeFilteredData}
              setCodeLevelFilteredData={setCodeLevelFilteredData}
              setFilterText={setFilterText}
              placeholder="Distribution Channel Name"
              disabledButton={editState || selectedRows.length > 0}
            />

            <div className="">
              {userPermissions.includes(hasAdd) && (
                <AddButton
                  buttonText="New Distribution Channel"
                  className={
                    selectedRows.length > 0 || editState
                      ? "opacity-50 float-right"
                      : "opacity-100 float-right"
                  }
                  onClick={() => handleAdd()}
                  disabled={editState || selectedRows.length > 0}
                />
              )}
            </div>
          </div>
          <div>
            {userPermissions.includes(hasDelete) ? (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note:</p>
                <span>Tick the box to deactivate some data.</span>
              </div>
            ) : (
              <div className="mb-4"></div>
            )}
          </div>
        </>
      )}
      <div
        className={
          addState ? "px-3 py-2 border-l-2  border-primary box-shadow" : ""
        }
      >
        {addState && (
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="text-base text-primary font-bold">
                Add New Distribution Channel
              </div>
              <div className="flex items-center space-x-2 pt-2 pb-2">
                <SaveButton
                  buttonText="Save"
                  disabled={disableSave}
                  onClick={() => setOpenModal(true)}
                />
                <CancelButton onClick={() => handleCancel()} />
              </div>
            </div>
            <div className="h-0.5 w-full border-b-2 border-secondary " />
          </div>
        )}
        <div className={addState ? "py-2" : ""}>
          <MaterialProducerCodeConfigTable
            data={
              addState
                ? newData
                : disChannelFilteredData?.length > 0
                ? disChannelFilteredData
                : distributionChannelData
            }
            isLoading={distriChannelData.isFetching}
            columns={matColumns}
            isDeactivate={true}
            onSelectionChange={handleSelectedRowsChange}
            selectedRows={selectedRows}
            selection={
              !addState && !editState && userPermissions.includes(hasDelete)
            }
            setOpenModal={setOpenModalDelete}
            paging={!addState}
          />
          <div>
            <ConfirmBoxModal
              ModalTitle={
                addState
                  ? "Add Distribution Channel"
                  : "Update Distribution Channel"
              }
              qConfirmation={
                addState
                  ? "Are you sure you want to Add this?"
                  : " Are you sure you want to Update this?"
              }
              isOpen={openModal}
              onClose={() => setOpenModal(false)}
              onClickFunction={() => {
                handleSave();
              }}
            />
            <ConfirmBoxDelete
              ModalTitle="Deactivate Distribution Channel"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => setOpenModalDelete(false)}
              onClickFunction={
                isBulkSelected ? handleBulkDelete : handleBulkDelete
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributionChannelTable;
